import { Component, OnInit, Input, ViewChildren, QueryList } from '@angular/core';
import { MenuService } from '../menu.service';
import { Menu } from '../menu.model';
import { MatMenuTrigger } from '@angular/material/menu';
import { StripeResponseService } from 'src/app/services/stripe-response.service';

@Component({
  selector: 'app-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrls: ['./horizontal-menu.component.scss'],
  providers: [MenuService]
})
export class HorizontalMenuComponent implements OnInit {
  @Input('menuParentId') menuParentId = 0;
  public menuItems: Array<Menu> = [];
  @ViewChildren(MatMenuTrigger) triggers!: QueryList<MatMenuTrigger>;

  constructor(public menuService: MenuService,
              public stripeResponseService: StripeResponseService) { }

  ngOnInit() {

    if (this.stripeResponseService.currentLoggedInUser === undefined){
      this.getDefaultMenus();
    } else {
      this.getUserAllowedMenus();
    }


    this.stripeResponseService.messageLoginPlus.subscribe((message) => {
      this.getUserAllowedMenus();
    });

    this.stripeResponseService.messageLogoutPlus.subscribe((message) => {
      this.getDefaultMenus();
    });

    // let roles = {
    //   admir:false,
    //   areaManager: false,
    //   branchManager: false,
    //   teamLeader: false,
    //   companyManager: false,
    //   subscriber: true
    // };

    // let roles = this.stripeResponseService.currentLoggedInUser?.roles || null;

    // console.log("Number of menu items, this user can access: ", this.menuItems.length)
  }

  public closeOthers(trigger: MatMenuTrigger) {
    const currentIndex: number = this.triggers.toArray().findIndex(t => t == trigger);
    this.triggers.forEach((menu, index) => {
      if (index != currentIndex) {
        menu.closeMenu();
      }
    });
  }

  public getAllowedRoles(rolesAllowed: any[], entriesToArray: any[]): number {

    const foundArray: any[] = [];
    rolesAllowed.forEach((ra: any) => {
      entriesToArray.filter(([key, value]: any) => {

        if (key === ra && value === true) {
          foundArray.push(ra);
          return ra;
        }

      });
    });

    if (foundArray.length > 0) {
      console.log('found');
      console.log('foundArray', foundArray);
    } else {
      console.log('No items matched');
    }

    return foundArray.length;

  }

  getDefaultMenus() {

    const roles: any[] =  [];

    if (roles === null) {
      alert("no roles assigned.");
      return false;
    } else {
      const entriesToArray = Object.entries(roles);
      console.log('entriesToArray', entriesToArray);
  
      this.menuItems = this.menuService.getHorizontalMenuItems();
      this.menuItems = this.menuItems.filter(item => item.parentId == this.menuParentId);
      this.menuItems = this.menuItems.filter(menuItem => {
        const rolesAllowed = menuItem.roles;
        if (rolesAllowed !== undefined) {
          const countAllowedRoles = this.getAllowedRoles(rolesAllowed, entriesToArray);
          const allowed = countAllowedRoles !== 0;
          return allowed;
        } else if (rolesAllowed === undefined) {
          return true;
        } else {
          return false;
        }
      });
    }

    return false;

  }

  getUserAllowedMenus() {

    // let roles = {
    //   admir:false,
    //   areaManager: false,
    //   branchManager: false,
    //   teamLeader: false,
    //   companyManager: false,
    //   subscriber: true
    // };

    const roles = this.stripeResponseService.currentLoggedInUser?.roles || null;

    if (roles === null) {
      alert("no roles assigned.");
      return false;
    } else {

      const entriesToArray = Object.entries(roles);
      console.log('entriesToArray', entriesToArray);
  
      this.menuItems = this.menuService.getHorizontalMenuItems();
      this.menuItems = this.menuItems.filter(item => item.parentId == this.menuParentId);
      this.menuItems = this.menuItems.filter(menuItem => {
        const rolesAllowed = menuItem.roles;
        if (rolesAllowed !== undefined) {
          const countAllowedRoles = this.getAllowedRoles(rolesAllowed, entriesToArray);
          const allowed = countAllowedRoles !== 0;
          return allowed;
        } else if (rolesAllowed === undefined) {
          return true;
        } else {
          return false;
        }
      });
    }
    return false;


  }
}
